import { render, staticRenderFns } from "./GrossPremiumAmount.vue?vue&type=template&id=59c92590"
import script from "./GrossPremiumAmount.vue?vue&type=script&lang=js"
export * from "./GrossPremiumAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports